import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { AvatarVerify } from '../OurTeam/AvatarVerify';
import { Cartridge } from '../GamesList/cartridge';
import { Platform } from '../GamesList/platform';
import { IGame } from 'src/providers/Games/useGames';
import { trimAddress } from '../../utils/parser';
import { Color } from 'src/theme/color';

export const GameResult = ({ data }: { data: IGame }) => {
	return (
		<Flex
			_hover={{ background: 'rgba(0,0,0, .1)', borderRadius: '5px' }}
			as={Link}
			to={`/game/${data.address}`}
		>
			<AvatarVerify
				isCompact
				avatar={data.media.logoUrl}
				name={data.name.slice(0, 1)}
				isVerified={data.listed}
			/>
			<Flex
				flexDirection="column"
				justifyContent="space-between"
				ml="24px"
			>
				<Flex
					flexDirection="column"
					gridGap="4px"
				>
					<Text
						fontSize="20px"
						lineHeight="24px"
					>
						{data.name}
					</Text>
					<Text
						fontSize="12px"
						lineHeight="14px"
						color={Color.BACKGROUND_TERTIARY}
					>
						{trimAddress(data.address)}
					</Text>
				</Flex>
				<Flex
					alignItems="center"
					gridGap="12px"
				>
					<Cartridge
						p="2px 4px"
						type={data.color}
						symbol={data.symbol}
					/>
					<Platform
						data={data.platforms}
						isGray={false}
						p="2px 4px"
					/>
				</Flex>
			</Flex>
		</Flex>
	);
};
